// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout principal */
.tabela-container {
    display: flex;
    margin: 20px;
    gap: 20px;
    padding-top: 100px;
    /* Espaço entre o filtro e a tabela */
}

.filter-container {
    width: 250px;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    margin-left: 20px;
}

.filter-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
}

.date-range {
    margin-bottom: 15px;
}

.date-range label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.date-range input[type="date"] {
    width: 100%;
    padding: 5px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.row-limit {
    margin-bottom: 15px;
}

.row-limit label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.row-limit input[type="number"] {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Estilos para o seletor de ordenação */
.order-direction {
    margin-bottom: 15px;
}

.order-direction label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.order-direction select {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    color: #555;
    cursor: pointer;
}

.order-direction select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.filter-item {
    margin-bottom: 10px;
}

.filter-item label {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #555;
}

.filter-item input[type="checkbox"] {
    margin-right: 10px;
    accent-color: #007bff;
    /* Cor do checkbox */
}

.filter-button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 15px;
    transition: background-color 0.3s ease;
}

.filter-button:hover {
    background-color: #0056b3;
}

.tabela-dados-container {
    flex: 1 1;
    /* Ocupa o restante do espaço disponível */
    overflow-x: auto;
    /* Adiciona scroll horizontal se necessário */
}

/* Estilos para a tabela */
.tabela-tq {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.tabela-tq th,
.tabela-tq td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
}

.tabela-tq th {
    background-color: #f4f4f4;
    font-weight: bold;
}

/* Estilos para a paginação */
.paginacao {
    display: flex;
    justify-content: center;
    gap: 5px;
    margin-top: 20px;
}

.paginacao button {
    padding: 5px 10px;
    border: 1px solid #ddd;
    background-color: #f4f4f4;
    cursor: pointer;
}

.paginacao button.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.paginacao button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}


.csv-button {
    width: 100%;
    padding: 10px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 15px;
    transition: background-color 0.3s ease;
}

.csv-button a {
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;
    height: 100%;
}

.csv-button:hover {
    background-color: #006400; /* Verde escuro */
}

.csv-button:focus {
    outline: 2px solid white;
}


.filter-button:hover {
    background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/components/tq-03-04-05/styles.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,0CAA0C;IAC1C,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;AAChD;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Layout principal */\n.tabela-container {\n    display: flex;\n    margin: 20px;\n    gap: 20px;\n    padding-top: 100px;\n    /* Espaço entre o filtro e a tabela */\n}\n\n.filter-container {\n    width: 250px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    margin-left: 20px;\n}\n\n.filter-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 15px;\n}\n\n.date-range {\n    margin-bottom: 15px;\n}\n\n.date-range label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.date-range input[type=\"date\"] {\n    width: 100%;\n    padding: 5px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.row-limit {\n    margin-bottom: 15px;\n}\n\n.row-limit label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.row-limit input[type=\"number\"] {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Estilos para o seletor de ordenação */\n.order-direction {\n    margin-bottom: 15px;\n}\n\n.order-direction label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.order-direction select {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #555;\n    cursor: pointer;\n}\n\n.order-direction select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.filter-item {\n    margin-bottom: 10px;\n}\n\n.filter-item label {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    color: #555;\n}\n\n.filter-item input[type=\"checkbox\"] {\n    margin-right: 10px;\n    accent-color: #007bff;\n    /* Cor do checkbox */\n}\n\n.filter-button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-top: 15px;\n    transition: background-color 0.3s ease;\n}\n\n.filter-button:hover {\n    background-color: #0056b3;\n}\n\n.tabela-dados-container {\n    flex: 1;\n    /* Ocupa o restante do espaço disponível */\n    overflow-x: auto;\n    /* Adiciona scroll horizontal se necessário */\n}\n\n/* Estilos para a tabela */\n.tabela-tq {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.tabela-tq th,\n.tabela-tq td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: left;\n}\n\n.tabela-tq th {\n    background-color: #f4f4f4;\n    font-weight: bold;\n}\n\n/* Estilos para a paginação */\n.paginacao {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    margin-top: 20px;\n}\n\n.paginacao button {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    background-color: #f4f4f4;\n    cursor: pointer;\n}\n\n.paginacao button.active {\n    background-color: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n.paginacao button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n\n.csv-button {\n    width: 100%;\n    padding: 10px;\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-top: 15px;\n    transition: background-color 0.3s ease;\n}\n\n.csv-button a {\n    text-decoration: none;\n    color: inherit;\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.csv-button:hover {\n    background-color: #006400; /* Verde escuro */\n}\n\n.csv-button:focus {\n    outline: 2px solid white;\n}\n\n\n.filter-button:hover {\n    background-color: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
